import { Component, computed, inject, LOCALE_ID, signal, DestroyRef, OnInit, effect } from '@angular/core';
import { FilterDateComponent } from '../../../../shared/ui/shared-filters/filter-date-component/filter-date-component';
import { FilterInput } from '../../../../shared/ui/shared-filters/filter-input/filter-input';
import { FilterSelectComponent } from '../../../../shared/ui/shared-filters/filter-select-component/filter-select-component';
import { FilterSortingComponent } from '../../../../shared/ui/shared-filters/filter-sorting-component/filter-sorting-component';
import { FormsModule } from '@angular/forms';
import { FilterItemSearch } from '../../../../shared/ui/shared-filters/filter-item-search/filter-item-search';
import { Tables } from '../../../../shared/ui/shared-tables/tables/tables';
import { ActionIcon } from '../../../../shared/ui/icons/action-icon/action-icon';
import { Router } from '@angular/router';
import { Pagination } from '../../../../shared/ui/shared-tables/pagination/pagination';
import {
  CancellationReason,
  ActionInterface,
  OrderByType,
  OrderDirType,
  UserInfo,
} from '../../../../../../src/app/pages/admin-dashboard/cancellation-reasons/cancellationReason.model';
import { ConfirmationDialog } from '../../../../shared/ui/confirmation-dialog/confirmation-dialog';
import { SuccessfulNotification } from '../../../../utils/successful-notification/successful-notification';
import { CancellationReasons } from '../../../../services/Cancellation Reasons/cancellation-reasons.service';
import { SubmitButton } from '../../../../shared/ui/Buttons/submit-button/submit-button';
import { Loading } from '../../../../utils/loading/loading';
import { Error } from '../../../public-user-component/auth/shared/error/error';
import { ErrorData } from "../../../../utils/error-data/error-data";
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { ScopeService } from '../../../../services/scope/scope-service';
import { SCOPES } from '../../../../services/scope/scope-constants';
import { validateCancellationReasonDates } from '../cancellation-reason.validators';
@Component({
  imports: [
    FilterInput,
    FilterDateComponent,
    FilterSelectComponent,
    FilterSortingComponent,
    FilterItemSearch,
    ActionIcon,
    Tables,
    Pagination,
    ConfirmationDialog,
    SuccessfulNotification,
    SubmitButton,
    Loading,
    Error,
    ErrorData,
    HasScopeDirective
],
  selector: 'app-cancellation-reasons-list-component',
  templateUrl: './cancellation-reasons-list-component.html',
  styleUrl: './cancellation-reasons-list-component.scss',
})
export class CancellationReasonsListComponent implements OnInit {
  private locale = inject(LOCALE_ID);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private cancellationReasonsService = inject(CancellationReasons);
    readonly SCOPES = SCOPES ;

  searchLabel = $localize`:@@cancellationReasonsSearchLabel:Search`;

  searchPlaceholder = $localize`:@@cancellationReasonsSearchPlaceholder:Search by reason name`;

  createdFromLabel = $localize`:@@cancellationReasonsCreatedFrom:Created On From`;

  createdToLabel = $localize`:@@cancellationReasonsCreatedTo:Created On To`;

  modifiedFromLabel = $localize`:@@cancellationReasonsModifiedFrom:Last Modified From`;

  modifiedToLabel = $localize`:@@cancellationReasonsModifiedTo:Last Modified To`;

  tableTitle = $localize`:@@cancellationReasonsTableTitle:Title`;

  tableType = $localize`:@@cancellationReasonsTableType:Type`;

  tableCreatedOn = $localize`:@@cancellationReasonsTableCreatedOn:Created On / By`;

  tableLastModified = $localize`:@@cancellationReasonsTableLastModified:Last Modified On / By`;

  lang = computed<'ar' | 'en'>(() => (this.isArabic() ? 'ar' : 'en'));

  isArabic = computed(() => this.locale.startsWith('ar'));
  loading = signal(true);
  errorMessage = signal<string | null>(null);

  search = signal('');

  createdFrom = signal<string | null>(null);
  createdTo = signal<string | null>(null);

  modifiedFrom = signal<string | null>(null);
  modifiedTo = signal<string | null>(null);


createdFromDateError = signal<string | null>(null);
createdToDateError = signal<string | null>(null);

modifiedFromDateError = signal<string | null>(null);
modifiedToDateError = signal<string | null>(null);

  orderBy = signal<OrderByType>('CREATION_DATE');

  orderDir = signal<OrderDirType>('DESC');

  sortOptions = [
    { value: 'TITLE', labelEn: 'Title', labelAr: 'العنوان' },
    { value: 'CREATION_DATE', labelEn: 'Created On', labelAr: 'تاريخ الإنشاء' },
    { value: 'LAST_MODIFICATION_DATE', labelEn: 'Last Modified', labelAr: 'آخر تعديل' },
  ];
  currentPage = signal(1);
  itemsPerPage = signal(25);
  totalItems = signal(0);
  reasons = signal<CancellationReason[]>([]);

  //  constructor() {
  //   this.fetchReasons();
  // }
  ngOnInit(): void {
    this.fetchReasons();
  }
  constructor() {
  effect(() => {
    this.createdFrom();
    this.createdTo();
    this.modifiedFrom();
    this.modifiedTo();

    this.validateDates();
  });
}

 validateDates() {
  const result = validateCancellationReasonDates(
    this.createdFrom(),
    this.createdTo(),
    this.modifiedFrom(),
    this.modifiedTo(),
    this.isArabic()
  );

  this.createdFromDateError.set(result.createdFromDateError);
  this.createdToDateError.set(result.createdToDateError);
  this.modifiedFromDateError.set(result.modifiedFromDateError);
  this.modifiedToDateError.set(result.modifiedToDateError);

  return result.isValid;
}
  fetchReasons() {
    this.loading.set(true);
    this.errorMessage.set(null);
    // console.log('Language:', this.lang());
    // console.log('isArabic:', this.isArabic());
    const subscription = this.cancellationReasonsService
      .getAllCancellationReasons(this.lang(), {
        quickSearch: this.search() || undefined,
        orderBy: this.orderBy(),
        orderDir: this.orderDir(),
        createdOnFrom: this.createdFrom() ?? undefined,
        createdOnTo: this.createdTo() ?? undefined,
        lastModifiedOnFrom: this.modifiedFrom() ?? undefined,
        lastModifiedOnTo: this.modifiedTo() ?? undefined,
      })
      .subscribe({
        next: (res) => {
          const sorted = [...res.list];
          // .sort((a, b) => Number(a.isEditable) - Number(b.isEditable));
          this.reasons.set(sorted);
          this.totalItems.set(res.total);
          this.errorMessage.set(null);
          this.loading.set(false);
        },
        error: () => {
          this.loading.set(false);
          this.errorMessage.set(
            this.isArabic() ? 'حدث خطأ أثناء تحميل البيانات.' : 'Something went wrong while loading data.',
          );
        },
      });
    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  toggleSortOrder() {
    this.orderDir.update((value) => (value === 'ASC' ? 'DESC' : 'ASC'));
    this.currentPage.set(1);
    this.fetchReasons();
  }

  applyFilters() {
      if (!this.validateDates()) {
        return;
      }
    this.currentPage.set(1);
    this.fetchReasons();
  }

  resetFilters() {
    this.search.set('');
    this.createdFrom.set(null);
    this.createdTo.set(null);
    this.modifiedFrom.set(null);
    this.modifiedTo.set(null);
   this.createdFromDateError.set(null);
  this.createdToDateError.set(null);

  this.modifiedFromDateError.set(null);
  this.modifiedToDateError.set(null);

    this.orderBy.set('CREATION_DATE');
    this.orderDir.set('DESC');
    this.currentPage.set(1);
    this.fetchReasons();
  }

  //table
  headerItems = computed(() => [
    {
      key: 'index',
      label: '#',
    },

    {
      key: 'title',
      label: this.tableTitle,
    },

    {
      key: 'type',
      label: this.tableType,
      type: 'status',
    },

    {
      key: 'createdOnBy',
      label: this.tableCreatedOn,
    },

    {
      key: 'lastModifiedOnBy',
      label: this.tableLastModified,
    },

    {
      key: 'actions',
      label: '',
      type: 'actions',
    },
  ]);

  actions: ActionInterface[] = [
    {
      id: 1,
      titleAr: 'تعديل',
      titleEn: 'Edit',
    },

    {
      id: 2,
      titleAr: 'حذف',
      titleEn: 'Delete',
    },
  ];
  // getActions(row: CancellationReason): ActionInterface[] {
  //   return [
  //     {
  //       id: 1,
  //       titleAr: 'تعديل',
  //       titleEn: 'Edit',
  //       disabled: !row.isEditable,
  //     },
  //     {
  //       id: 2,
  //       titleAr: 'حذف',
  //       titleEn: 'Delete',
  //       disabled: !row.isEditable,
  //     },
  //   ];
  // }

  tableRows = computed(() => {
    return this.reasons().map((item, index) => ({
      id: item.id,
      index: (this.currentPage() - 1) * this.itemsPerPage() + index + 1,
      title: this.locale.startsWith('ar') ? item.titleAr : item.titleEn,
      type: {
        titleEn: item.isEditable ? 'Custom' : 'System-defined',
        titleAr: item.isEditable ? 'مخصص' : 'معرف من النظام',
      },
      createdOn: item.createdOn,
      createdBy: item.isEditable ? (item.createdBy as UserInfo)?.fullName : 'System',
      lastModifiedOn: item.lastModifiedOn,
      lastModifiedBy: item.lastModifiedBy?.fullName ?? null,
      isEditable: item.isEditable,
    }));
  });

  handleAction(event: any) {
    const row = event.entity;

    if (!row.isEditable) {
      return;
    }

    if (event.actionId === 1) {
      const reason = this.reasons().find((item) => item.id === row.id);

      if (!reason) {
        return;
      }

      this.router.navigate(['admin/cancellation/edit-cancellation-reason', reason.id], {
        state: {
          id: reason.id,
          titleAr: reason.titleAr,
          titleEn: reason.titleEn,
          isEditable: reason.isEditable,
        },
      });
    }

    if (event.actionId === 2) {
      this.openDeleteConfirmation(row.id);
    }
  }

  pagedRows = computed(() => this.tableRows());

  totalPages = computed(() => Math.ceil(this.totalItems() / this.itemsPerPage()));
  startItem = computed(() => (this.totalItems() ? (this.currentPage() - 1) * this.itemsPerPage() + 1 : 0));
  endItem = computed(() => Math.min(this.currentPage() * this.itemsPerPage(), this.totalItems()));

  getPageNumbers() {
    const pages: number[] = [];

    for (let i = 1; i <= this.totalPages(); i++) {
      pages.push(i);
    }

    return pages;
  }
  onPreviousPage() {
    if (this.currentPage() > 1) {
      this.currentPage.update((page) => page - 1);
      this.fetchReasons();
    }
  }

  onNextPage() {
    if (this.currentPage() < this.totalPages()) {
      this.currentPage.update((page) => page + 1);
      this.fetchReasons();
    }
  }

  onGoToPage(page: number) {
    this.currentPage.set(page);
    this.fetchReasons();
  }

  onChangePageNumber(size: number) {
    this.itemsPerPage.set(+size);
    this.currentPage.set(1);
    this.fetchReasons();
  }

  onPageSizeChange() {
    this.currentPage.set(1);
  }

  /////////////////////////

  //delete
  showDeleteConfirmation = signal(false);

  showDeleteError = signal(false);

  deleteReasonTarget = signal<CancellationReason | null>(null);

  successMessage = signal<string | null>(null);
  showReasonInUseError = signal(false);
  deleteTitle = $localize`:@@cancellationReasonDeleteTitle:Delete Cancellation Reason`;

  deleteDescription = $localize`:@@cancellationReasonDeleteConfirmation:Are you sure you want to delete this cancellation reason?`;

  deleteButton = signal($localize`:@@delete:Delete`);

  cancelButton = $localize`:@@cancellationReasonCancel:Cancel`;
  Loading = $localize`:@@cancellationReasonLoading:Loading...`;

  closeButton = $localize`:@@close:Close`;

  // deleteError = signal<string | null>(null);
  deleteError = signal('');

  openDeleteConfirmation(id: number) {
    this.deleteError.set('');
    const reason = this.reasons().find((r) => r.id === id);

    if (!reason) return;

    this.deleteReasonTarget.set(reason);
    this.showDeleteConfirmation.set(true);
  }

  confirmDelete() {
    this.deleteButton.set(this.Loading);

    const reason = this.deleteReasonTarget();

    if (!reason) return;

    const reasonName = this.isArabic() ? reason.titleAr : reason.titleEn;

   const subscription = this.cancellationReasonsService.deleteCancellationReason(reason.id).subscribe({
    next: () => {
      this.deleteButton.set($localize`:@@delete:Delete`);
      this.reasons.update((list) =>
    list.filter((item) => item.id !== reason.id)
  );

  this.totalItems.update((total) => total - 1);
      this.successMessage.set(
        `${$localize`:@@cancellationReasonDeletedSuccessfully:Cancellation reason`} "${reasonName}" ${$localize`:@@cancellationReasonCreatedSuccessfully2: successfully `}`
      );

      this.showDeleteConfirmation.set(false);
      this.deleteReasonTarget.set(null);
      this.deleteError.set('');

      setTimeout(() => {
        this.successMessage.set(null);
      }, 3000);
    },

    error: (error) => {
      this.deleteButton.set($localize`:@@delete:Delete`);

      this.deleteError.set(
        this.isArabic()
          ? error?.messageAr || 'حدث خطأ أثناء حذف سبب الإلغاء.'
          : error?.messageEn || 'Something went wrong while deleting the cancellation reason.'
      );
    },
  });
this.destroyRef.onDestroy(() => subscription.unsubscribe());
}

  closeDeleteConfirmation() {
    this.showDeleteConfirmation.set(false);

    this.deleteReasonTarget.set(null);
  }
}
